module.exports = __webpack_public_path__ + "static/media/power-on.9d5be959.svg";